import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import HeroSection from "@/components/home/HeroSection";
import ServicesSection from "@/components/home/ServicesSection";
import HowItWorksSection from "@/components/home/HowItWorksSection";
import ProjectsSection from "@/components/home/ProjectsSection";
import WhyChooseUsSection from "@/components/home/WhyChooseUsSection";
import PricingSection from "@/components/home/PricingSection";
import AboutSection from "@/components/home/AboutSection";
import LeadCaptureSection from "@/components/home/LeadCaptureSection";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";

const HomePage = () => {
  return (
    <div data-testid="home-page" className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <HowItWorksSection />
        <ProjectsSection />
        <WhyChooseUsSection />
        <PricingSection />
        <AboutSection />
        <LeadCaptureSection />
      </main>
      <Footer />

      {/* Floating Mobile CTA */}
      <div className="floating-cta md:hidden">
        <a href="tel:+17711871113">
          <Button
            data-testid="floating-cta"
            className="bg-[#C2410C] hover:bg-[#9A3412] text-white w-14 h-14 rounded-full shadow-lg"
          >
            <Phone className="w-6 h-6" />
          </Button>
        </a>
      </div>
    </div>
  );
};

export default HomePage;
